









import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Popup } from 'vant';
import { Picker } from 'vant';
import { Search } from 'vant';
import { Field, CellGroup } from 'vant';
import 'vant/lib/index.css';
import { delNullProperty } from "@/utils/index";
import axios from "axios";

@Component({
    components: { vanPopup:Popup, vanPicker:Picker, vanSearch:Search, vanField:Field, vanCellGroup:CellGroup}
})
export default class Home extends Vue {
    @Prop({default: () => ([]) }) columns!: Array<any>;
    @Prop({default: false}) show!: Boolean;
    @Prop({default: false}) search!: Boolean;

    private school = ''
    private page = 1
    private axios = null;
    private allNum = null
    private checkIndex = 0
    private confirmText = ''
    private idIndex = null

    created(){
      this.createAxios();
      this.getSchoolList()
    }
    createAxios() {
      const origin = location.hostname; //当前访问域名
      let requestBase = "";
      if (process.env.NODE_ENV === "development") {
        requestBase = process.env.VUE_APP_BASE_CRM_API_PROXY;
      } else {
        if (origin.indexOf("-testserver") > -1) {
            requestBase = process.env.VUE_APP_DEV_API;
        } else {
            requestBase = process.env.VUE_APP_MASTER_API;
        }
      }
      const config = {
        baseURL: requestBase,
        timeout: 30 * 1000, // Timeout
      };
      this.axios = axios.create(config);
    }
    onSearch(val) {
      this.school = val
      this.page = 1
      this.getSchoolList()
    }
    onCancels() {
      this.school = ''
    }
    async getSchoolList() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.axios
        .post(
          "/tools/getSchoolList",
          delNullProperty({
          name: this.school,
          page: this.page,
          })
        )
        .then(({ data }) => {
          this.allNum = data.data.allNum
          if(this.school){
            this.columns = data.data.schoolList
            const arr = [...this.columns, ...data.data.schoolList]
            // this.checkIndex = 0
            this.columns = arr.map(item => ({ id: item.id, text: item.name?item.name:item.text }))
          }else{
            this.columns = [...this.columns, ...data.data.schoolList]
            this.columns = this.columns.map(item => ({ id: item.id, text: item.name?item.name:item.text }))
          }
          loading.close();
        })
        .catch((err) => {
            loading.close();
        });
    }

    onConfirm(value, index) {
      this.confirmText = value
      this.idIndex = value.id
      this.checkIndex = index
      this.$emit('listenSchool',value)
      this.$emit('handleSchool',this.columns)
    }
    onChange(picker, value, index) {
      const schoolLength = this.columns.length
      if(this.search) {
        if (index > schoolLength - 3) {
            if(schoolLength < this.allNum) {
              this.page += 1
              this.getSchoolList()
              this.checkIndex = index
            } else {
                console.log('最后一页')
            }
        }
      }
    }
    onCancel(value, index) {
      if(!this.confirmText){
        this.checkIndex = 0
      }else {
        // index = this.checkIndex
      }
      this.show = false
      this.school = ''
      this.$emit('listenSchool',false)
    }

    @Watch('show')
    handleWatchShow() {
      if(this.show){
        if(this.search){
          const indexs = this.columns.indexOf(this.columns.filter(d=>d.id === this.idIndex)[0])
          this.$nextTick(() => {
            (this.$refs.picker as HTMLFormElement).setIndexes([indexs])
          })
        }else {
          this.$nextTick(() => {
            (this.$refs.picker as HTMLFormElement).setIndexes([this.checkIndex])
          })
        }
      }

      if(!this.show) {
        this.$emit("update:show", false)
      }

    }
}
